export enum TopbarActions {
  TOPBAR_SET_STATE = '[TOPBAR] Topbar Set State',
  TOPBAR_DELETE_STATE = '[TOPBAR] Topbar Delete State',
  TOPBAR_CLICKED_ACTION = '[TOPBAR] Topbar Clicked Action',
  TOPBAR_RESET_CLICKED_ACTION = '[TOPBAR] Topbar Reset Clicked Action',
  TOPBAR_SET_TITLE = '[TOPBAR] Topbar Set Title',
}
